import { relations } from 'drizzle-orm';
import { pgTable, text, uuid } from 'drizzle-orm/pg-core';
import { defaultColumns } from './defaultColumns';
import { userRoleTable } from './userRole.sql';
import { userLocationTable } from './userLocation.sql';
import { userTeamTable } from './userTeam.sql';
import { userTeamNotificationSettingTable } from './userTeamNotificationSetting.sql';
export const userTable = pgTable('user', {
  id: uuid('id').primaryKey().defaultRandom(),
  cognitoId: text('cognitoId'),
  firstName: text('firstName'),
  lastName: text('lastName'),
  email: text('email').notNull(),
  ...defaultColumns,
});

export const userRelations = relations(userTable, ({ many }) => ({
  userLocations: many(userLocationTable),
  userTeams: many(userTeamTable),
  userRoles: many(userRoleTable),
  userTeamNotificationSettings: many(userTeamNotificationSettingTable),
}));
